/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from "react";
import { useMediaQuery } from "react-responsive";
import {
  BodyContent,
  TitleContainer,
  ImageLoadContainer,
  ImageContainer,
  ImageContent,
  Imagem,
  ImageFormatText,
  IconsUploadContainer,
  InputLabelFileContent,
  LabelFile,
  InputFile,
  FileConfigurationContainer,
  FileConfiguration,
  TitleContent,
  AttributeContainer,
} from "./style";

import { t } from "i18next";
import PageTitle from "../../shared/pageTitle/PageTitle";
import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import Label from "../../shared/label/Label";
import { ChannelContext } from "../../../context/channel";
import DeleteIcon from "../../shared/Icons/DeleteIcon";
import UploadIcon from "../../shared/Icons/UploadIcon";
import { ColorResult } from "react-color";


export const FILE_ERRORS = {
  NONE: "",
  SIZE: "size",
  FORMAT: "format",
  DIMENSION: "dimension",
};

export interface IFileConfiguration {
  uploadedFileErrorType: string;
}

const messageFormat = t('dashboard.image.format');

const Appearance = () => {
  const dashboardContext = useContext(ChannelContext);
  const [uploadedFile, setUploadedFile] = useState<any>(
    dashboardContext.appearenceImageFile
  );
  const [upload, setUpload] = useState<boolean>(
    dashboardContext.appearenceImageUrl !== "" ? true : false
  );
  const [fileImageUrl, setFileImageUrl] = useState(
    dashboardContext.appearenceImageUrl
  );
  const [uploadedFileErrorType, setUploadedFileErrorType] = useState<string>(
    FILE_ERRORS.NONE
  );
  const [errorMessage, setErrorMessage] = useState(messageFormat);

  const isSmallScreen = useMediaQuery({ query: "(max-width: 1050px)" });

  useEffect(() => {
    dashboardContext.setAppearenceImageUrl(uploadedFile);
  }, [uploadedFile]);

  let uploadedImageDimensions = {};

  var uploadedFileError = "";
  var isFileUploadFailed = false;

  const checkFileType = (file: any) => {
    const acceptedTypes = ["svg", "png", "jpg", "jpeg"];
    const fileType = file.type.replace("image/", "");
    if (!acceptedTypes.includes(fileType)) {
      uploadedFileError = FILE_ERRORS.FORMAT;
      setUploadedFileErrorType(FILE_ERRORS.FORMAT);
      isFileUploadFailed = true;
    }
  };

  const checkFileSize = (file: any) => {
    if (file.size > 1000000) {
      uploadedFileError = FILE_ERRORS.SIZE;
      setUploadedFileErrorType(FILE_ERRORS.SIZE);
      isFileUploadFailed = true;
    }
  };

  const checkFileDimension = (fileDimension: any) => {
    if (fileDimension.width > 140 || fileDimension.height > 42) {
      uploadedFileError = FILE_ERRORS.DIMENSION;
      setUploadedFileErrorType(FILE_ERRORS.DIMENSION);
      isFileUploadFailed = true;
    }
  };

  const getImageDimensions = async (fileInput: any) => {
    const oFReader = new FileReader();
    oFReader.readAsDataURL(fileInput);
    oFReader.onload = async (event: any) => {
      var image = new Image();
      image.src = event.target.result;
      image.onload = function () {
        uploadedImageDimensions = { width: image.width, height: image.height };
      };
    };
  };

  const checkImageErrorMessage = (uploadedFileError: any) => {
    switch (uploadedFileError) {
      case FILE_ERRORS.FORMAT:
        setErrorMessage(
          t('dashboard.image.error.format')!
        );
        return;
      case FILE_ERRORS.SIZE:
        setErrorMessage(
          t('dashboard.image.error.size')!
        );
        return;
      case FILE_ERRORS.DIMENSION:
        setErrorMessage(
          t('dashboard.image.error.dimensions', {maxImageWidth: 120, maxImageHeight: 40})!
        );
        return;
      case FILE_ERRORS.NONE:
        setErrorMessage(messageFormat);
        return;
      default:
        return;
    }
  };

  const handleLoadFile = async (event: any) => {
    const [file] = event.target.files;
    checkFileType(file);
    checkFileSize(file);
    await new Promise((resolve) => setTimeout(resolve, 900));
    checkFileDimension(uploadedImageDimensions);

    if (isFileUploadFailed) {
      checkImageErrorMessage(uploadedFileError);
      setFileImageUrl("");
      setUpload(false);
      setUploadedFile("");
    } else {
      setFileImageUrl(URL.createObjectURL(file));
      setUpload(true);
      setUploadedFile(file);
    }
  };

  const handleRemoveFile = () => {
    setUpload(false);
    setUploadedFileErrorType(FILE_ERRORS.NONE);
    uploadedFileError = "";
    checkImageErrorMessage(uploadedFileError);
  };
  
  useEffect(() => {
    dashboardContext.setAppearenceImageFile(uploadedFile);
    dashboardContext.setAppearenceImageUrl(fileImageUrl);
  }, [uploadedFile, fileImageUrl]);

  return (
    <BodyContent>
      <PageTitle>{t('dashboard.appearance.title')}</PageTitle>
      <TitleContainer>
        {upload ? (
          <ImageLoadContainer>
            <Label>Logo</Label>
            <ImageContainer>
              <ImageContent>
                <Imagem src={fileImageUrl} alt="logo preview" id="imageId" />
                <ImageFormatText>
                  {messageFormat}
                </ImageFormatText>
              </ImageContent>
              <IconsUploadContainer>
                <UploadIcon
                  handleLoadFile={(event) => handleLoadFile(event)}
                  idForUploadButton="upload"
                />
                <DeleteIcon
                  style={{ marginLeft: "24px" }}
                  handleRemoveFile={handleRemoveFile}
                />
              </IconsUploadContainer>
            </ImageContainer>
          </ImageLoadContainer>
        ) : (
          <InputLabelFileContent>
            <Label style={{ width: "134px" }}>Logo</Label>
            <LabelFile className="label" htmlFor="input-file">
              {isSmallScreen ? t('dashboard.image.add') : t('dashboard.image.addImage')}
            </LabelFile>
            <InputFile
              type="file"
              id="input-file"
              accept="image/*"
              onChange={(event) => handleLoadFile(event)}
            />
            <FileConfigurationContainer>
              <FileConfiguration uploadedFileErrorType={uploadedFileErrorType}>
                {errorMessage}
              </FileConfiguration>
            </FileConfigurationContainer>
          </InputLabelFileContent>
        )}
        <TitleContent>
          <Label style={{ width: "134px" }}>{t('dashboard.color.primary')}</Label>
          <AttributeContainer
            onBlur={() =>
              dashboardContext.setAppearencePrimaryColor(
                dashboardContext.appearencePrimaryColor
              )
            }
          >
          <InputColorPicker
            color={dashboardContext.appearencePrimaryColor}
            handleChangeColor={(e: ColorResult) => dashboardContext.setAppearencePrimaryColor(e.hex)} 
          />
          </AttributeContainer>
        </TitleContent>
        <TitleContent>
          <Label style={{ width: "134px" }}>{t('dashboard.color.secondary')}</Label>
          <AttributeContainer
            onBlur={() =>
              dashboardContext.setAppearenceSecondaryColor(
                dashboardContext.appearenceSecondaryColor
              )
            }
          >
          <InputColorPicker
            color={dashboardContext.appearenceSecondaryColor}
            handleChangeColor={(e: ColorResult) => dashboardContext.setAppearenceSecondaryColor(e.hex)}

          />
          </AttributeContainer>
        </TitleContent>
      </TitleContainer>
    </BodyContent>
  );
};

export default Appearance;
